// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-01-2025
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-01-2025
// ***********************************************************************
// <copyright file="tenant-style-loader.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utility for dynamically loading a tenant-specific CSS
//     stylesheet into the document head based on the applicant's tenant.
// </summary>
// ***********************************************************************

window.tenant = window.tenant || {};

/**
 * Dynamically injects a CSS file into the document head based on the provided href.
 * If a tenant stylesheet has already been added, it updates its href instead of injecting a new one.
 *
 * @function loadCss
 * @memberof window.tenant
 * @param {string} href - The path to the CSS file to be loaded.
 */
window.tenant.loadCss = function (href) {
    const existing = document.getElementById('tenant-style');

    if (existing) {
        existing.href = href;
        return;
    }

    const link = document.createElement('link');
    link.id = 'tenant-style';
    link.rel = 'stylesheet';
    link.href = href;
    link.type = 'text/css';

    document.head.appendChild(link);
};

/**
 * Dynamically sets or updates the favicon for the application.
 * If a favicon link already exists, its href will be updated. Otherwise, a new link is injected.
 * A cache-busting query string is automatically added to force browsers to refresh the icon.
 *
 * @function setFavicon
 * @memberof window.tenant
 * @param {string} href - The path to the favicon file.
 */
window.tenant.setFavicon = function (href) {
    document.querySelectorAll("link[rel='icon'], link[rel='shortcut icon']")
        .forEach(e => e.remove());

    const link = document.createElement("link");
    link.rel = "shortcut icon";
    link.type = "image/png";
    link.href = href + "?v=" + Date.now();

    document.head.appendChild(link);
};
